module.exports = __webpack_public_path__ + "img/imagen4.e9857ce9.png";